import React from "react";
import { Modal } from "react-bootstrap";
import Resources from "../../../types/Resources";
import ChecklistRadioOptions from "../../Common/ChecklistRadioOptions";
import WorkOnRoadChecklistFormState from "../../../types/forms/Permits/Conditions/WorkOnRoadChecklistFormState";

type WorkOnRoadChecklistModalProps = {
    formState: WorkOnRoadChecklistFormState;
    onChange: (fn: (prevValue: WorkOnRoadChecklistFormState) => WorkOnRoadChecklistFormState) => void;
    resources: Resources;
    show: boolean;
    onHide: () => void;
    canManageContent: boolean;
};

function WorkOnRoadChecklistModal({
    formState,
    onChange,
    resources,
    show,
    onHide,
    canManageContent
}: WorkOnRoadChecklistModalProps) {
    function changeHandler(key: keyof WorkOnRoadChecklistFormState, value: any) {
        onChange((prevValue) => {
            const updatedFormState: WorkOnRoadChecklistFormState = {
                ...prevValue,
                [key]: { ...prevValue[key], value }
            };

            return updatedFormState;
        });
    }

    return (
        <Modal show={show} onHide={onHide} size="xl">
            <Modal.Header closeButton>
                <h1 className="h5">{resources.get("WorkOnRoadChecklist")}</h1>
            </Modal.Header>
            <Modal.Body>
                <ul className="list-unstyled">
                    <li className="m-2">
                        <ChecklistRadioOptions
                            id="has-ta-plan"
                            labelText={resources.get("HasTAPlan")}
                            onChange={(updatedValue) => changeHandler("hasTAPlan", updatedValue)}
                            resources={resources}
                            value={formState.hasTAPlan.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <ChecklistRadioOptions
                            id="has-at-least-two-traffic-sign-boards"
                            labelText={resources.get("HasAtLeastTwoTrafficSignBoards")}
                            onChange={(updatedValue) => changeHandler("hasAtLeastTwoTrafficSignBoards", updatedValue)}
                            resources={resources}
                            value={formState.hasAtLeastTwoTrafficSignBoards.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <ChecklistRadioOptions
                            id="all-workers-have-correct-road-work-training"
                            labelText={resources.get("AllWorkersHaveCorrectRoadWorkTraining")}
                            onChange={(updatedValue) => changeHandler("allWorkersHaveCorrectRoadWorkTraining", updatedValue)}
                            resources={resources}
                            value={formState.allWorkersHaveCorrectRoadWorkTraining.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <ChecklistRadioOptions
                            id="all-workers-have-correct-protective-equipment"
                            labelText={resources.get("AllWorkersHaveCorrectProtectiveEquipment")}
                            onChange={(updatedValue) => changeHandler("allWorkersHaveCorrectProtectiveEquipment", updatedValue)}
                            resources={resources}
                            value={formState.allWorkersHaveCorrectProtectiveEquipment.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <ChecklistRadioOptions
                            id="can-unprotected-individuals-pass-safely"
                            labelText={resources.get("CanUnprotectedIndividualsPassSafely")}
                            onChange={(updatedValue) => changeHandler("canUnprotectedIndividualsPassSafely", updatedValue)}
                            resources={resources}
                            value={formState.canUnprotectedIndividualsPassSafely.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                </ul>
            </Modal.Body>
        </Modal>
    );
}

export default WorkOnRoadChecklistModal;
